let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fpTAr")).then(() => parcelRequire('2lmAK'));